<template>
  <div>
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Informacje zgłoszeniowe</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    </v-card>
    <v-card class="mt-2 pb-1">
      <v-form @submit.prevent="updateRunner"novalidate>
        <v-toolbar flat dense dark color="tertiary">
          <v-toolbar-title>Pakiet</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div class="subheading text-xs-center mt-5">Wybierz pakiet</div>
        <package-selection
          v-model="form.package"
          :options="availablePackages"
          :formErrors="formErrors"
          @input="updateRunner">
        </package-selection>
        <v-layout row wrap justify-end>
          <v-flex class="step-buttons">
            <v-btn v-if="updateMode" type="submit" color="primary">Dalej</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import {updateRunnerDataPackage, getRunnerDataPackage} from './api'
import * as types from '@/store/mutation-types'
import store from '@/store'
import { mapGetters } from 'vuex'
import PackageSelection from './PackageSelection'

export default {
  components: {PackageSelection},
  validators: {
  },
  data () {
    return {
      updateMode: true,
      formErrors: {},
      availablePackages: [],
      runner: {},
      form: {}
    }
  },
  computed: {
    ...mapGetters(['allPackagesFullOptions', 'authUser', 'getPackageById', 'getTrainerById'])
  },
  beforeRouteEnter (to, from, next) {
    if (parseInt(to.params.id) === store.getters.authUser.id) {
      next()
    } else {
      next({name: 'login'})
    }
  },
  mounted () {
    Promise.all([this.p1]).then(() => {
      getRunnerDataPackage(this.$route.params.id).then((data) => {
        this.runner = data
        if (this.runner.trainer) {
          for (let pck of this.allPackagesFullOptions) {
            if (pck.trainer === this.runner.trainer || !pck.trainer) {
              this.availablePackages.push(pck)
            }
          }
        } else {
          this.availablePackages = this.allPackagesFullOptions
        }
        this.form = {...data}
        this.validation.reset()
      })
    })
  },
  created () {
    this.p1 = this.$store.dispatch(types.ALL_PACKAGES_REQUEST)
  },
  methods: {
    updateRunner () {
      this.$validate().then(success => {
        if (success) {
          updateRunnerDataPackage(parseInt(this.$route.params.id), this.form).then((data) => {
            this.validation.reset()
            this.$emit('runner-application-data-updated', data)
            if (data.trainer) {
              this.$router.push({name: 'runner-application-data-first', params: {id: this.$route.params.id}})
            } else {
              this.$router.push({name: 'runner-application-data-trainer', params: {id: this.$route.params.id}})
            }
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>
<style>
div.v-list__tile__action div.v-input.v-input--selection-controls.v-input--checkbox.theme--light {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/runners/RunnerApplicationDataPackage.vue